import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalHeader, DotLegalSwitch } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import DotLegalSection from "@common/components/dotLegalSection/DotLegalSection";
import { IContractGlobalSettingsDialogProps, useContractGlobalSettingsHook } from "./ContractGlobalSettings.hooks";
import { useContractGlobalSettingsStyles } from "./ContractGlobalSettings.styles";

const explanationKeys = [
    "archiveContractsWhenExpiredNightly",
    "archiveContractsWhenExpiredAutoRenewal",
    "archiveContractsWhenExpiredAlreadyExpired",
    "archiveContractsWhenExpiredObligations",
    "archiveContractsWhenExpiredObligationsWithEndDate",
];

function ContractGlobalSettingsDialog(props: IContractGlobalSettingsDialogProps) {
    const styles = useContractGlobalSettingsStyles();
    const { translateString } = useTranslation();
    const { isLoading, saveModel, editedSaveModel, modelUpdater, onSave, inProgress } = useContractGlobalSettingsHook(props);

    return (
        <DotLegalDialog
            size="md"
            header={translateString("contractSettings")}
            buttonOkText={translateString("save")}
            open
            isLoading={isLoading}
            inProgress={inProgress}
            onDialogClose={() => props.onDialogClose()}
            onOkClick={() => onSave()}
            disableBackdropOnCloseIfValueChange={editedSaveModel}
        >
            <Box sx={styles.content}>
                <DotLegalSection>
                    <Box sx={styles.sectionContent}>
                        <DotLegalHeader center headerStyle="small">
                            {translateString("archiveContractsWhenExpiredHeader")}
                        </DotLegalHeader>

                        <Box component="ul" sx={styles.explanation}>
                            {explanationKeys.map((key) => (
                                <li key={key}>{translateString(key)}</li>
                            ))}
                        </Box>

                        <Box sx={styles.toggleRow}>
                            <DotLegalSwitch
                                checked={saveModel.archiveContractsWhenExpired}
                                rightLabel={translateString("archiveContractsWhenExpiredSwitch")}
                                greyUncheckedTrack
                                onChange={modelUpdater.onArchiveContractsWhenExpiredChange}
                            />
                        </Box>
                    </Box>
                </DotLegalSection>
            </Box>
        </DotLegalDialog>
    );
}

export default ContractGlobalSettingsDialog;
